<!-- <div class="absolute inset-0 z-30 flex flex-col bg-base-100 mt-23.5 ml-28 pr-28"> -->
<section class="w-[calc(100%-80px)] absolute top-20 left-20 bottom-0 z-20 flex flex-col cursor-default bg-white">
  <article class="mt-4 ml-8 mr-28 flex-1 flex flex-col min-h-0">
    <div class="shrink-0">
      <app-restrictions-search-bar
        [restrictionsType]="restrictionsType"
        [restrictionsTarget]="restrictionsTarget"
        [stopOptions]="originOptions"
        [townId]="townId"
        [routeId]="routeId"
        [bulkSelectMode]="bulkSelectMode"
        [selectedCount]="selectedRestrictionIds.size"
        [pageSize]="restrictions.pagination.size"
        [existingRestrictions]="displayedRestrictions"
        [whiteListDraftMode]="isWhiteListDraft"
        [whiteListDraftSize]="whiteListDraft?.length ?? 0"
        (backClicked)="goBack()"
        (restrictionAdded)="onRestrictionAdded($event)"
        (changeRestrictionTypeEventEmitter)="onRestrictionTypeChangeRequested($event)"
        (confirmWhiteListDraftClicked)="confirmWhiteListDraft()"
        (cancelWhiteListDraftClicked)="cancelWhiteListDraft()"
        (searchEventEmitter)="search($event)"
        (pageSizeChanged)="changePageSize($event)"
        (bulkDeleteClicked)="toggleBulkSelectMode()"
        (cancelBulkClicked)="cancelBulkSelectMode()"
        (confirmBulkDeleteClicked)="showBulkDeleteRestrictionsModal()"
      >
        @if (areaOptions.length > 1 && !isWhiteListDraft) {
          <app-custom-toggle
            class="shrink-0"
            [id]="'restrictions-target-toggle'"
            [selectedValue]="restrictionsTarget"
            [options]="restrictionsTargetToggleOptions"
            (action)="changeRestrictionsTarget(restrictionsTarget === RestrictionsTarget.STOPS ? RestrictionsTarget.AREAS : RestrictionsTarget.STOPS)"
          />
        }
      </app-restrictions-search-bar>
    </div>
    <div id="restrictionsContainer" class="flex-1 overflow-auto scrollable-content px-3 mb-5">
      <div class="grid grid-cols-12 mt-5 mb-4 text-center sticky top-0 z-10 bg-white">
        <label class="flex justify-center items-center col-span-2 font-semibold text-base">
          <img [src]="images.origin" alt="origin" class="h-4 w-4 z-10 mr-1.5" />
          {{ literalService.get(restrictionsTarget === RestrictionsTarget.AREAS ? "services.routes.restrictions.areas.headerOrigin" : "services.routes.restrictions.headerOrigin", true) }}
        </label>
        <label class="flex justify-center items-center col-span-9 font-semibold text-base">
          <img [src]="images.destination" alt="destination" class="h-4 w-4 z-10 mr-1.5" />
          {{ restrictionsTarget === RestrictionsTarget.AREAS ?
              literalService.get("services.routes.restrictions.areas.headerDestinations", true)
            : restrictionsType === RestrictionsType.BLACK_LIST ?
              literalService.get("services.routes.restrictions.headerDestinations.blackList", true)
            :
              literalService.get("services.routes.restrictions.headerDestinations.whiteList", true)
          }}
        </label>
        <label class="flex justify-center items-center col-span-1 font-semibold text-sm whitespace-nowrap">
          @if (bulkSelectMode) {
            <input type="checkbox" [checked]="allRestrictionsSelected" (change)="toggleSelectAllRestrictions($event)" />
          } @else {
            <img [src]="images.services.restrictions.moreOptions" alt="moreOptions" class="h-6 w-6 mr-1.5 shrink-0 filter-primary-purple-light" />
            {{ literalService.get("services.routes.restrictions.headerOptions", true) }}
          }
        </label>
      </div>
      @if (restrictions.isFetchingRestrictions && !isWhiteListDraft) {
        <ngx-skeleton-loader [count]="restrictions.pagination.numberOfElements || 10" appearance="line" [theme]="{ 'height': '64px' }"></ngx-skeleton-loader>
      } @else if (displayedRestrictions.length) {
        @for (restriction of displayedRestrictions; track restriction.originStop.id) {
          <div class="selectable-row grid grid-cols-12 py-2 mb-2 rounded border border-neutrals-grey-02 cursor-pointer" data-restriction-row [class.bg-neutrals-grey-01]="$even" [class.selected-row]="selectedRestriction?.originStop?.id === restriction.originStop.id" (click)="bulkSelectMode ? toggleRestrictionSelection(restriction) : showRestrictionDetails(restriction)">
            <label class="flex justify-center items-center text-center col-span-2 py-3 px-1 font-semibold text-base border-r border-neutrals-grey-02">
              {{ restriction.originStop.name }}
            </label>
            <div class="flex mx-4 items-center col-span-9 py-3 text-left truncate">
              <div [id]="'destinations-' + restriction.originStop.id" class="truncate" [tooltip]="utilsService.visibleTooltip('destinations-' + restriction.originStop.id) ? getDestinationNames(restriction) : ''" [visibleTooltip]="utilsService.visibleTooltip('destinations-' + restriction.originStop.id)" [position]="TooltipPosition.ABOVE">
                @for (destination of restriction.restrictedDestinations; track destination.destination.id) {
                  <span class="mx-3 font-semibold text-base">{{ destination.destination.name }}</span>
                }
              </div>
            </div>
            <label class="flex justify-center items-center col-span-1 py-3 border-l border-neutrals-grey-02">
              @if (bulkSelectMode) {
                <input type="checkbox" [checked]="isRestrictionSelected(restriction)" (click)="$event.stopPropagation()" (change)="toggleRestrictionSelection(restriction)" />
              } @else {
                <img [src]="images.services.restrictions.delete" alt="delete" class="h-6 w-6 cursor-pointer" [class.opacity-30]="!isWhiteListDraft && isLastSavedWhiteListRestriction" (click)="showDeleteRestrictionModal(restriction); $event.stopPropagation()" />
              }
            </label>
          </div>
        }
      } @else {
        <div class="flex flex-col items-center justify-start p-6 gap-4 mt-10">
          <img [src]="images.services.restrictions.emptyState" class="w-64 h-auto" />
          <p class="text-3xl font-bold text-neutrals-grey-04">{{ literalService.get(restrictionsTarget === RestrictionsTarget.AREAS ? 'services.routes.restrictions.areas.emptyState' : 'services.routes.restrictions.emptyState', true) }}</p>
        </div>
      }
    </div>
    @if (isWhiteListDraft ? displayedRestrictions.length : (restrictions.value.length || restrictions.isFetchingRestrictions)) {
      <section class="h-14 shrink-0">
        <app-pagination [pagination]="currentPagination" [loading]="!isWhiteListDraft && restrictions.isFetchingRestrictions && !restrictions.pagination.totalPages" [baseUrl]="'/restrictions'" (changePage)="changePage($event)" />
      </section>
    }
  </article>
</section>
<app-restriction-details
  [restriction]="selectedRestriction"
  [restrictionsType]="restrictionsType"
  [stopOptions]="originOptions"
  (closeDetails)="closeRestrictionDetails()"
  (save)="onRestrictionSaved($event)"
/>
<app-modal-confirmation [id]="'deleteRestriction'" [modal]="deleteRestrictionModal" [shown]="deleteRestrictionShowed" [hidden]="!deleteRestrictionShowed" [title]="'services.routes.restrictions.deleteModal.title'" [text]="'services.routes.restrictions.deleteModal.text'" [sameLineButtons]="true" [loading]="deletingRestriction" (action)="deleteRestrictionAction()" />
<app-modal-confirmation [id]="'bulkDeleteRestrictions'" [modal]="bulkDeleteRestrictionsModal" [shown]="bulkDeleteRestrictionsShowed" [hidden]="!bulkDeleteRestrictionsShowed" [title]="'services.routes.restrictions.bulkDelete.title'" [text]="bulkDeleteText" [sameLineButtons]="true" [loading]="deletingBulkRestrictions" (action)="bulkDeleteRestrictionsAction()" />
<app-modal-confirmation [id]="'changeRestrictionType'" [modal]="changeRestrictionTypeModal" [shown]="changeRestrictionTypeShowed" [hidden]="!changeRestrictionTypeShowed" [title]="changeRestrictionTypeTitle" [text]="changeRestrictionTypeText" [sameLineButtons]="true" [loading]="changingRestrictionType" (action)="changeRestrictionTypeAction()" />
